<template>
  <div id="order">
    <el-container>
      <el-header><i class="fas fa-shopping-cart fa-fw"></i> 発注内容確認</el-header>
      <el-main>
        <div id="est_cond">
          <table>
          <tr>
            <th>配布方法</th>
            <td>{{ distribute_way[EstimateCond.segment] }}</td>
            <th>税別金額</th>
            <td>{{ Number(EstimateData.totalPrice).toLocaleString() }}円</td>
          </tr>
          <tr>
            <th>サイズ</th>
            <td>{{ EstimateCond.size }}</td>
            <th>消費税額</th>
            <td>{{ Number(EstimateData.totalPriceIncTax - EstimateData.totalPrice).toLocaleString() }}円</td>
          </tr>
          <tr>
            <th>納品期限</th>
            <td>{{ EstimateData.deadline }}</td>
            <th>合計金額</th>
            <td>{{ Number(EstimateData.totalPriceIncTax).toLocaleString() }}円</td>
          </tr>
          <tr>
            <th>配布期間</th>
            <td colspan="3" class="center">{{ EstimateData.period }}</td>
          </tr>
          <tr>
            <th>納品場所</th>
            <td colspan="3" class="left">ポストエクスプレス栃木支社<br>（株式会社アシストパル内）<br>〒320-0861<br>栃木県宇都宮市西1-4-3</td>
          </tr>
          </table>
        </div>
        <el-alert v-if="EstimateData.qty < 2000" title="2000部未満の発注は、基本料2,000円（税別）が加算されています。" type="info" show-icon :closable="false"></el-alert>
        <order-area-tbl :arealist="area_list"></order-area-tbl>
        <el-alert :title="message.msg" type="error" v-if="message.err"></el-alert>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              <span>納品予定日（入力必須）</span>
            </div>
          </template>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="納品予定日の他、連絡事項等"
            v-model="comment">
          </el-input>
        </el-card>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              <span>支払方法</span>
            </div>
          </template>
          <div>
            <label><input type="radio" v-model="payment" value="invoice">振込</label>
            <label><input type="radio" v-model="payment" value="credit" disabled>クレジットカード</label>
          </div>
          <div v-show="payment == 'credit'" class="payjp-form">
            <div id="v2-demo" class="payjs-outer"><!-- ここにフォームが生成されます --></div>
          </div>
        </el-card>
        <el-alert title="クレジットカード払いは現在準備中です。" type="info" show-icon :closable="false"></el-alert>
      </el-main>
      <el-footer>
        <el-button type="primary" @click="order">発注する</el-button>
        <el-button @click="back">戻る</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { clsEstimateCond } from '@/types/clsEstimateCond';
import { clsEstimateData } from '@/types/clsEstimateData';
import OrderAreaTbl from '@/components/OrderAreaTbl.vue';
import { app } from '../main';
import { distribute_way } from '../BizTerms';

export default defineComponent({
  components: { OrderAreaTbl },
  props: ['user'],
  setup(props) {
    const router = useRouter()
    if(!props.user.login) {
      console.log('Can\'t access Order for not login.')
      router.back()
    }
    const payment = 'invoice'
    let EstimateCond = new clsEstimateCond('nokina','B4')
    const econd = sessionStorage.getItem('estimateCond')
    if(!econd) throw new Error('Order: econd undefined.')
    EstimateCond = JSON.parse(econd)
    
    let EstimateData = new clsEstimateData()
    const estdata = sessionStorage.getItem('estimateData')
    if(!estdata) throw new Error('Order: estdata undefined.')
    EstimateData = JSON.parse(estdata)
    
    let area_list: string[] = []
    const areas = sessionStorage.getItem('areas')
    if(!areas) throw new Error('Order: areas undefined.')
    area_list = JSON.parse(areas)
    
    const message = reactive({
      msg: '',
      err: false,
      clear() {
        this.msg = '';
        this.err = false;
      },
    })
    const comment = ref('')
    const back = () => {
      router.back()
    }
    const order = () => {
      if(comment.value == '') {
        app.config.globalProperties.$notify({
          title: 'Warning',
          message: '納品予定日を入力してください。',
          type: 'warning'
        })
      }else {
        let json = {
          'cond'		:EstimateCond,
          'estimate':EstimateData,
          'areas'		:area_list,
          'csrf'		:props.user.csrf,
          'comment'	:comment.value
        };
        //console.log(JSON.stringify(json));
        const api_path = app.config.globalProperties.api_path
        fetch(api_path + 'ajax/order.php', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(json)
        })
        .then(response => response.json())
        .then(json => {
          //console.log(json);
          if(json['result'] == 'failure') {
            throw new Error(json.error)
          }
          message.clear()
          router.push('/thanks?order_id=' + json['order_id'])
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
      }
    }

    return {
      payment,
      EstimateCond,
      EstimateData,
      message,
      comment,
      back,
      order,
      area_list,
      distribute_way,
    }
  }
})
</script>

<style scoped>
#order {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#order .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#order .el-container {
    width: 550px;
    margin: 0 auto;
}
#est_cond {
    background-color: #F5F7FA;
    margin-bottom: 10px;
    padding: 7px;
}
#est_cond table {
    width: 100%;
    margin-bottom: 5px;
}
#est_cond table th {
    color: #717171;
}
#est_cond table td {
    border-bottom: solid 1px #dadada;
    padding: 10px 0;
    text-align: right;
    color: #606266;
}
#est_cond table td.center {
  text-align: center;
}
#est_cond table td.left {
  text-align: left;
}
#order .el-main .el-alert {
    margin-bottom: 10px;
}
#order .box-card {
    color: #6f6f6f;
    margin: 10px 0;
}
</style>